export default __webpack_public_path__ + "static/media/Icon_Warning.b634e268.svg";